/* 🤖 this file was generated by svg-to-ts */
export const emperorIconLogin2: {
  name: 'login_2';
  data: string;
} = {
  name: 'login_2',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M12 2C6.823 2 2.55 5.95 2.051 11H13.59l-2.3-2.292 1.41-1.42 4.7 4.699 -4.71 4.715 -1.42-1.42 2.29-2.3H2.02c.5 5.04 4.772 9 9.949 9 5.51 0 10-4.49 10-10 0-5.52-4.49-10-10-10Z"/></svg>`
};
